module.exports = __webpack_public_path__ + "img/h2.d18ae246.webp";